import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { UserCog, LogOut, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Faixa fixa no topo do painel quando um Super-Admin está impersonando uma Loja.
 * Some por conta própria se não houver impersonação ativa.
 */
export const ImpersonationBanner = () => {
  const [info, setInfo] = useState(null); // { impersonated_by, loja_name, user_name }
  const [ending, setEnding] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [meRes, lojaRes] = await Promise.all([
          axios.get(`${API}/auth/me`, { withCredentials: true }),
          axios.get(`${API}/lojas/mine`, { withCredentials: true }).catch(() => null),
        ]);
        if (cancelled) return;
        if (meRes.data?.impersonated_by) {
          setInfo({
            impersonated_by: meRes.data.impersonated_by,
            loja_name: lojaRes?.data?.name || meRes.data.loja?.name || "esta Loja",
            user_name: meRes.data.name,
          });
        }
      } catch { /* anonimo — nada a fazer */ }
    })();
    return () => { cancelled = true; };
  }, []);

  const endImpersonation = async () => {
    setEnding(true);
    try {
      await axios.post(`${API}/impersonation/end`, {}, { withCredentials: true });
      toast.success("Voltando ao Super-Admin…");
      setTimeout(() => { window.location.href = "/admin"; }, 400);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha ao sair da impersonação.");
      setEnding(false);
    }
  };

  if (!info) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-40 bg-gradient-to-r from-purple-800 via-purple-700 to-purple-800 text-white shadow-lg border-b border-purple-500/50"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 justify-between flex-wrap">
        <div className="flex items-center gap-3 text-sm">
          <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center animate-pulse">
            <UserCog className="w-4 h-4" />
          </div>
          <div>
            <div className="font-bold leading-tight">
              🕵️ Modo Impersonação Ativo
            </div>
            <div className="text-[11px] text-purple-100 leading-tight">
              Você entrou como <strong>{info.user_name}</strong> em <strong>{info.loja_name}</strong>.
              Todas as suas ações estão registradas na trilha de auditoria.
            </div>
          </div>
        </div>
        <button
          data-testid="impersonation-end-btn"
          onClick={endImpersonation}
          disabled={ending}
          className="flex items-center gap-2 bg-white text-purple-800 hover:bg-purple-50 disabled:opacity-70 px-4 py-2 rounded-lg text-xs uppercase tracking-widest font-bold transition-all"
        >
          {ending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <LogOut className="w-3.5 h-3.5" />}
          {ending ? "Saindo…" : "Voltar ao Super-Admin"}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
